import Navbar from './Navbar';

const dim = 15;
const locationMap = {
  tl:{ alignItems:'start', justifyContent:'start' },
  tr:{ alignItems:'start', justifyContent:'flex-end' },
  bl:{ alignItems:'flex-end', justifyContent:'flex-end' },
  br:{ alignItems:'flex-end', justifyContent:'start' },
}

function CornerLocker({rotation,onEvent,locationCode,selected}){

  return (

    <div addLocation={locationCode} onClick={(e) => {
      onEvent({
        event:e,
        position:locationCode
      })
      /*
        type:"change",
        event:e,
        properties:{
          "position.base":locationCode
        }
      });*/
    }} class="show-child-on-hover clickable dark-hoverable" style={{
      border:'1px solid #ccc',
      width:dim,height:dim,
      background:(selected?"blue":undefined),
    }}>
    </div>

  )
}


const locationCodes = [
  ["tl","tm","tr"],
  ["ml","mm","mr"],
  ["bl","bm","br"],
];


const externalButtons = [
  ["Above","before","v"],
  ["Below","after","v"],
  ["Left","before","h"],
  ["Right","after","h"]
]

const options = ["text","scalebar","region"].map(_id => ({_id}));

export default function TemplatePositionLock({selectedFigureItems,data,args,onEvent,external,}){

  let selectedPosition = data?.position?.base;

  let buttons = (external!==false?externalButtons:[])

  let [above,below,left,right] = buttons.map(([relPos,befAft,d]) => {

    return (
      <button onClick={(e) => {
        onEvent({
          e,
          direction:d,
          relativeLocation:befAft
        })
        
      }} class="small-margin">{relPos}</button>
    )

  })


  return (


    <div style={{
        textAlign:'center',
      padding:(external!==false?0:40),
    }} class={"sg-col v-center"}>

      {above}

      <div class="sg-row v-center">

        {left}

        <div style={{width:dim * 3,height:dim * 3, 
          border:'1px solid #ccc',
          position:'relative',
        }}>




          {locationCodes.map(row => {
            return <div class="sg-row">{row.map(code => {
              return <CornerLocker {...{
                locationCode:code,
                onEvent,
                selected:(selectedPosition === code),
              }}/>
            })}</div>


          })}




        </div>

        {right}

      </div>

      {below}
    </div>

  )
}
